/** @format */

import React, { memo } from 'react';
import styled, { keyframes } from 'styled-components';

// #region ::: PARTIALS
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
;`;

const Spinner = styled.div<{ reduceSpinnerSize?: boolean }>`
  border: 5px solid ${({ theme }) => theme.colors.joivy.white};
  border-top: 5px solid #4a55ff;
  border-radius: 50%;
  width: ${({ reduceSpinnerSize }) => (reduceSpinnerSize ? '20px' : '50px')};
  height: ${({ reduceSpinnerSize }) => (reduceSpinnerSize ? '20px' : '50px')};
  animation: ${spin} 1s linear infinite;
  border-color: rgb(0 0 0) rgb(255, 255, 255) rgb(255, 255, 255);
`;

const WrapperSpinner = styled.div<{ reduceSpinnerSize?: boolean; isBookingFooter?: boolean }>`
  display: flex;
  justify-content: ${({ reduceSpinnerSize, isBookingFooter }) =>
    isBookingFooter ? 'center' : reduceSpinnerSize ? 'flex-start' : 'flex-end'};
  align-items: center;
`;

interface Props {
  isBookingFooter?: boolean;
  reduceSpinnerSize?: boolean;
}

const Loading = ({ reduceSpinnerSize, isBookingFooter }: Props) => (
  <WrapperSpinner reduceSpinnerSize={reduceSpinnerSize} isBookingFooter={isBookingFooter}>
    <Spinner reduceSpinnerSize={reduceSpinnerSize} />
  </WrapperSpinner>
);
// #endregion

export const UILoaderCardRoom = memo(({ reduceSpinnerSize, isBookingFooter }: Props) => (
  <Loading reduceSpinnerSize={reduceSpinnerSize} isBookingFooter={isBookingFooter} />
));
